import type React from 'react';

import { observer } from 'mobx-react';

import { useCustomListStore } from 'bz-clinical/controls/settings/clinical-lists/stores/custom-list-store';

import Button from 'bz-core-controls/controls/general/button';
import { useMenuStore } from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';

import { useAction } from 'bz-utilities/hooks/action';
import useComputed from 'bz-utilities/hooks/computed';

import { useAddStore } from '../../stores/add-store';

export interface IProps {
  route: string;

  onAdd?: () => void;
}

const AddControlButton: React.FC<IProps> = observer(({ route, onAdd }) => {
  const store = useCustomListStore();
  const menu = useMenuStore();
  const addStore = useAddStore();

  const disabled: boolean = useComputed(() => {
    return addStore.description.trim() === '';
  }, [addStore]);

  const onClick = useAction((): void => {
    menu.onAdd(route, addStore.description.trim());
    store.onApply(menu!.onExtract());

    addStore.description = '';
    onAdd?.();
  }, [addStore, store, menu]);

  return <Button label="Add" small={true} disabled={disabled} onClick={onClick} />;
});

AddControlButton.displayName = 'AddControlButton';

export default AddControlButton;
